export enum Type {
    Finite = 0,
    Range,
  }